export default "__VITE_ASSET__CiHxHs8A__"